import { EH_VISIT_TS } from "./constants.es.js";
import { g as getCookieHandler } from "../../../cookieHandler-ac6954c1.js";
import { getVisitId } from "./visitId.es.js";
import "./adapter.es.js";
import "../../../cookies-04bd2321.js";
import "../../../utils/logger.es.js";
import "../timeOnPage/timeOnPage.es.js";
import "../../../v4-88c20f3b.js";
import "./processUrlVisitId.es.js";
import "./utils.es.js";
const convertVisitIdTsToSeconds = (visitIdTs) => {
  if (!visitIdTs)
    return 0;
  const visitDate = new Date(visitIdTs);
  if (isNaN(visitDate.getTime()))
    return 0;
  return Math.floor(visitDate.getTime() / 1e3);
};
const getVisitIdData = (adapter) => {
  const cookieHandler = getCookieHandler(adapter);
  const cookies = cookieHandler.parseCookies();
  const visitId = getVisitId();
  const visitIdTs = convertVisitIdTsToSeconds(cookies[EH_VISIT_TS]);
  return { visitId, visitIdTs };
};
export {
  getVisitIdData
};
